// Pure factories for toast/history entries built from a mapped ticket (the
// same shape `ticketMapper.mapTicketResponse` produces for table rows). No
// React, no network — safe to unit test directly.

export function toHistoryEntry(ticket) {
  return {
    id: ticket.id,
    ticketNo: ticket.id,
    subject: ticket.title,
    category: ticket.category,
    priority: ticket.priority,
    receivedAt: ticket.created || new Date(),
    ticketRef: ticket,
  };
}

// The spec calls out "High priority" for the warning severity; "urgent" is a
// strictly higher priority tier in this codebase's mapping and is treated the
// same way here (an assumption, since the spec doesn't mention it directly).
export function toastSeverityForPriority(priority) {
  return priority === 'high' || priority === 'urgent' ? 'warning' : 'info';
}

export function createTicketToast(ticket) {
  return {
    id: ticket.id,
    kind: 'ticket',
    severity: toastSeverityForPriority(ticket.priority),
    ticketNo: ticket.id,
    subject: ticket.title,
    ticketRef: ticket,
    createdAt: Date.now(),
  };
}

export function createAggregateToast(count) {
  return {
    id: `aggregate-${Date.now()}`,
    kind: 'aggregate',
    severity: 'info',
    count,
    createdAt: Date.now(),
  };
}
